import { ArrowUpRight } from "lucide-react";
import { trustPillars } from "../data/content";

export function Trust(): JSX.Element {
  return (
    <section
      id="sicherheit"
      aria-labelledby="trust-title"
      className="relative overflow-hidden bg-primary py-24 text-on-primary sm:py-28 lg:py-32"
    >
      {/* Subtle paper-grain on the Forest surface */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 -z-0 opacity-[0.18]"
        style={{
          backgroundImage:
            "radial-gradient(circle at 1px 1px, rgba(255,255,255,0.08) 1px, transparent 0)",
          backgroundSize: "26px 26px",
        }}
      />
      <div className="container-welope relative">
        <div className="bloom-on-scroll mx-auto max-w-3xl text-center">
          <p className="font-body text-label-md uppercase tracking-[0.18em] text-primary-fixed">
            <span aria-hidden>›</span> Sicherheit · DSGVO
          </p>
          <h2
            id="trust-title"
            className="mt-4 font-headline text-headline-xl text-on-primary sm:text-[52px] sm:leading-[1.04] sm:tracking-[-0.025em]"
          >
            Deine Daten bleiben
            <br />
            <span className="relative inline-block">
              deine Daten.
              <span
                aria-hidden
                className="absolute -bottom-1 left-0 right-0 h-1.5 rounded-full bg-secondary/70"
              />
            </span>
          </h2>
          <p className="mt-6 font-body text-body-lg leading-[1.55] text-primary-fixed">
            Wir nehmen Datenschutz nicht als Feature, sondern als Grundrecht. Hier ist, was
            das bei Welope konkret heißt.
          </p>
          <a
            href="/ratgeber/dsgvo-tier-apps-worauf-achten"
            className="mt-4 inline-flex items-center gap-1.5 font-body text-label-md font-medium text-primary-fixed hover:underline"
          >
            Ratgeber: DSGVO bei sozialen Netzwerken für Tiere
            <ArrowUpRight className="h-4 w-4" aria-hidden="true" />
          </a>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-5 sm:grid-cols-2">
          {trustPillars.map((pillar, idx) => {
            const { Icon } = pillar;
            return (
              <div
                key={pillar.title}
                className="bloom-on-scroll card-bloom group relative overflow-hidden bg-primary-container p-md transition-transform duration-300 ease-out-expo hover:-translate-y-1"
                style={{ transitionDelay: `${idx * 70 + 80}ms` }}
              >
                <div
                  aria-hidden
                  className="pointer-events-none absolute -right-6 -top-6 h-32 w-32 rounded-full bg-primary-fixed/20 blur-2xl"
                />
                <div className="relative flex h-12 w-12 items-center justify-center rounded-lg bg-primary-fixed/35">
                  <Icon
                    className="h-6 w-6 text-primary-fixed transition-transform group-hover:scale-110"
                    strokeWidth={1.6}
                    aria-hidden="true"
                  />
                </div>
                <h3 className="relative mt-5 font-headline text-headline-md leading-tight text-on-primary">
                  {pillar.title}
                </h3>
                <p className="relative mt-2 font-body text-body-md leading-[1.55] text-primary-fixed">
                  {pillar.description}
                </p>
              </div>
            );
          })}
        </div>

        <div className="bloom-on-scroll mt-12 flex flex-col items-center gap-5 rounded-xl border border-primary-fixed/30 bg-primary-container/60 p-md text-center sm:p-lg">
          <p className="font-headline text-headline-md text-on-primary">
            Kein Detail-Recht, das wir verstecken würden. Lese alles in Ruhe:
          </p>
          <div className="flex flex-wrap items-center justify-center gap-3">
            {[
              { label: "Datenschutzerklärung", href: "https://app.welope.de/datenschutz" },
              { label: "AGB", href: "https://app.welope.de/agb" },
            ].map((link) => (
              <a
                key={link.href}
                href={link.href}
                rel="noopener noreferrer"
                target="_blank"
                className="group inline-flex items-center gap-2 rounded-full border-2 border-primary-fixed bg-transparent px-6 py-3 font-body text-label-md text-primary-fixed transition-all duration-200 ease-out-expo hover:-translate-y-0.5 hover:bg-primary-fixed hover:text-primary hover:shadow-bloom-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-fixed focus-visible:ring-offset-2 focus-visible:ring-offset-primary"
              >
                {link.label}
                <ArrowUpRight
                  className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                  aria-hidden="true"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
